import { takeEvery, fork, put, all, call, delay } from "redux-saga/effects"
import { getDashboardAPI, getLOBNetPremiumAPI, getEmployeeAPI, getCompanyGraphAPI, getLOBGraphAPI } from "./api"
import * as types from "./constant"
import {
  getCompanyDashAPISuccess,
  getCompanyDashAPIFail,
  getCompanyDashAPISuccessLife,
  getLOBNetPremiumAPISuccessGen,
  getLOBNetPremiumAPISuccessLife,
  getLOBNetPremiumAPIFail,
  getEmployeeSuccess,
  getEmployeeFail,
  getCompanyGraphSuccess,
  getCompanyGraphFailed,
  getLOBGraphSuccess,
  getLOBGraphFailed,
  getCompanyLifeGraphSuccess,
  getLOBLifeGraphSuccess,
} from "./action"
function* getCompanyDash(payload) {
  try {
    const response = yield call(getDashboardAPI, payload.payload)
    if (response && (response.status === 200 || response.status === 201)) {
      yield delay(400)
      if (payload.payload === 1) {
        yield put(getCompanyDashAPISuccess(response.data))
      } else if (payload.payload === 2) {
        yield put(getCompanyDashAPISuccessLife(response.data))
      }
    } else {
      throw response
    }
  } catch (error) {
    yield put(getCompanyDashAPIFail(error.response.data))
  }
}

//  DASHBOARD :
function* companyDashboardAPI() {
  yield takeEvery(types.GET_COMPANY_DASH_API_START, getCompanyDash)
}

// LOB :
function* getLOBNetPremiumAsync(payload) {
  try {
    const response = yield call(getLOBNetPremiumAPI, payload.payload)
    if (response && (response.status === 200 || response.status === 201)) {
      yield delay(400)

      if (payload.payload === 1) {
        yield put(getLOBNetPremiumAPISuccessLife(response.data))
      } else if (payload.payload === 2) {
        yield put(getLOBNetPremiumAPISuccessGen(response.data))
      }
    } else {
      throw response
    }
  } catch (error) {
    yield put(getLOBNetPremiumAPIFail(error.response.data))
  }
}

function* getLOBNetPremium() {
  yield takeEvery(types.GET_LOB_PREMIUM_API_START, getLOBNetPremiumAsync)
}

// Employee-Graph
function* getEmployeeAsync(payload) {
  try {
    const response = yield call(getEmployeeAPI, payload.payload)
    if (response) {
      yield delay(400)
      yield put(getEmployeeSuccess(response.data.netpremium_data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(getEmployeeFail(error.response.data))
  }
}

function* getEmployeeFunc() {
  yield takeEvery(types.GET_EMPLOYEE_API_START, getEmployeeAsync)
}



// Graph
function* getCompanyGraphAsync(payload) {
  try {
    const response = yield call(getCompanyGraphAPI, payload.payload)
    if (response && (response.status === 200 || response.status === 201)) {
      yield delay(400)
      if (payload.payload === 1) {
        yield put(getCompanyGraphSuccess(response.data))
      } else if (payload.payload === 2) {
        yield put(getCompanyLifeGraphSuccess(response.data))
      }
    } else {
      throw response
    }
  } catch (error) {
    yield put(getCompanyGraphFailed(error.response.data))
  }
}

function* getCompanyGraph() {
  yield takeEvery(types.GET_COMPANY_GRAPH, getCompanyGraphAsync)
}





function* getLOBGraphAsync(payload) {
  try {
    const response = yield call(getLOBGraphAPI, payload.payload)
    if (response && (response.status === 200 || response.status === 201)) {
      yield delay(400)
      if (payload.payload === 1) {
        yield put(getLOBGraphSuccess(response.data))
      } else if (payload.payload === 2) {
        yield put(getLOBLifeGraphSuccess(response.data))
      }
    } else {
      throw response
    }
  } catch (error) {
    yield put(getLOBGraphFailed(error.response.data))
  }
}

function* getLOBGraph() {
  yield takeEvery(types.GET_LOB_GRAPH, getLOBGraphAsync)
}

function* DashboardAPI() {
  yield all([
    fork(companyDashboardAPI), 
    fork(getLOBNetPremium), 
    fork(getEmployeeFunc),
    fork(getCompanyGraph),
    fork(getLOBGraph),
  ])
}

export default DashboardAPI
